import { produce } from "immer";
import {
  FETCH_CARE_HOME_GROUPS,
  FETCH_CARE_HOME_GROUPS_SUCCESS,
  FETCH_CARE_HOME_GROUPS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_CARE_HOME_GROUP,
  ADD_CARE_HOME_GROUP_SUCCESS,
  ADD_CARE_HOME_GROUP_FAILURE,
  //
  EDIT_CARE_HOME_GROUP,
  EDIT_CARE_HOME_GROUP_SUCCESS,
  EDIT_CARE_HOME_GROUP_FAILURE,
  //
  DELETE_CARE_HOME_GROUP,
  DELETE_CARE_HOME_GROUP_SUCCESS,
  DELETE_CARE_HOME_GROUP_FAILURE,
  //
  SEARCH_CARE_HOME_GROUP,
  SEARCH_CARE_HOME_GROUP_SUCCESS,
  SEARCH_CARE_HOME_GROUP_FAILURE,
  //
  GENERATE_COMPANY_CODE,
  GENERATE_COMPANY_CODE_SUCCESS,
  GENERATE_COMPANY_CODE_FAILURE,
  //
  GENERATE_COMPANY_ADDRESS,
  GENERATE_COMPANY_ADDRESS_SUCCESS,
  GENERATE_COMPANY_ADDRESS_FAILURE,
  //
  TOGGLE_INVITE_MODAL,
  INVITE_COMPANY,
  INVITE_COMPANY_SUCCESS,
  INVITE_COMPANY_FAILURE,
  //
  TOGGLE_DIRECT_CLAIM_MODAL,
  DIRECT_CLAIM_COMPANY,
  DIRECT_CLAIM_COMPANY_SUCCESS,
  DIRECT_CLAIM_COMPANY_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingCareHomeGroups: false,
  careHomeGroups: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentCareHomeGroup: {},
  isSearching: false,
  searchHomeGroupList: [],
  // Delete
  isDeleting: false,
  //
  isGeneratingCompanyCode: false,
  isGeneratingCompanyAddress: false,
  // Invitation
  inviteModal: { open: false, company: null },
  isInviting: false,
  directClaimModal: { open: false, company: null },
  isDirectClaiming: false,
};

const CareHomeGroupsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_CARE_HOME_GROUPS:
        draft.isFetchingCareHomeGroups = true;
        draft.currentCareHomeGroup = {};
        break;
      case FETCH_CARE_HOME_GROUPS_SUCCESS:
        draft.isFetchingCareHomeGroups = false;
        draft.careHomeGroups = action.payload;
        break;
      case FETCH_CARE_HOME_GROUPS_FAILURE:
        draft.isFetchingCareHomeGroups = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentCareHomeGroup = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentCareHomeGroup = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_CARE_HOME_GROUP:
        draft.isSubmitting = true;
        break;
      case ADD_CARE_HOME_GROUP_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_CARE_HOME_GROUP_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_CARE_HOME_GROUP:
        draft.isSubmitting = true;
        break;
      case EDIT_CARE_HOME_GROUP_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_CARE_HOME_GROUP_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_CARE_HOME_GROUP:
        draft.isDeleting = true;
        break;
      case DELETE_CARE_HOME_GROUP_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_CARE_HOME_GROUP_FAILURE:
        draft.isDeleting = false;
        break;
      //search
      case SEARCH_CARE_HOME_GROUP:
        draft.isSearching = true;
        draft.searchHomeGroupList = [];
        break;
      case SEARCH_CARE_HOME_GROUP_SUCCESS:
        draft.isSearching = false;
        draft.searchHomeGroupList = action.payload;
        break;
      case SEARCH_CARE_HOME_GROUP_FAILURE:
        draft.isSearching = false;
        draft.searchHomeGroupList = [];
        break;
      case GENERATE_COMPANY_CODE:
        draft.isGeneratingCompanyCode = true;
        break;
      case GENERATE_COMPANY_CODE_SUCCESS:
        draft.isGeneratingCompanyCode = false;
        break;
      case GENERATE_COMPANY_CODE_FAILURE:
        draft.isGeneratingCompanyCode = false;
        break;
      case GENERATE_COMPANY_ADDRESS:
        draft.isGeneratingCompanyAddress = true;
        break;
      case GENERATE_COMPANY_ADDRESS_SUCCESS:
        draft.isGeneratingCompanyAddress = false;
        break;
      case GENERATE_COMPANY_ADDRESS_FAILURE:
        draft.isGeneratingCompanyAddress = false;
        break;
      case TOGGLE_INVITE_MODAL:
        draft.inviteModal = action?.payload;
        break;
      case INVITE_COMPANY:
        draft.isInviting = true;
        break;
      case INVITE_COMPANY_SUCCESS:
        draft.isInviting = false;
        draft.inviteModal = { open: false, company: null };
        break;
      case INVITE_COMPANY_FAILURE:
        draft.isInviting = false;
        break;
      case TOGGLE_DIRECT_CLAIM_MODAL:
        draft.directClaimModal = action?.payload;
        break;
      case DIRECT_CLAIM_COMPANY:
        draft.isDirectClaiming = true;
        break;
      case DIRECT_CLAIM_COMPANY_SUCCESS:
        draft.isDirectClaiming = false;
        draft.directClaimModal = { open: false, company: null };
        break;
      case DIRECT_CLAIM_COMPANY_FAILURE:
        draft.isDirectClaiming = false;
        break;
      default:
        return state;
    }
  });

export default CareHomeGroupsReducer;
